// extracted by mini-css-extract-plugin
module.exports = {"root":"_3XQe8","button":"_2J24P"};